import React from 'react';

import cx from '../../utils/classnames';

import styles from './rakutenAward.module.scss';

type Props = {
  /** Custom style for wrapper */
  className?: string;
  /** Custom style for image */
  imageClassName?: string;
  /** image src URL */
  image?: string;
  /** title of the component */
  title: string;
};

function RakutenAward(props: Props) {
  const { className, imageClassName, image, title, ...rest } = props;

  return (
    <div className={cx(className, styles.container)} {...rest}>
      <img key={title} className={imageClassName} src={image} alt={title} />
    </div>
  );
}

export default RakutenAward;
